import { render, staticRenderFns } from "./WriteTicket.vue?vue&type=template&id=12dc3a0e&"
import script from "./WriteTicket.vue?vue&type=script&lang=js&"
export * from "./WriteTicket.vue?vue&type=script&lang=js&"
import style0 from "./WriteTicket.vue?vue&type=style&index=0&id=12dc3a0e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports